// extracted by mini-css-extract-plugin
export default {"success":"Success_success__t84Jv","success__icon":"Success_success__icon__aMjek"};